/**
 * Page FAQ (template-parts/faq-content.php) : [data-faq].
 *  - sélecteur de catégorie → rechargement avec ?cat=
 *  - liens de sous-catégories (.categories a) → scroll doux + état actif
 *  - scroll-spy sur les groupes de questions (.question--wrapper)
 *  - liens profonds : ?cat=&term=<slug>&question=<id> (préselection, scroll, ouverture)
 * Dépend de 40-accordion.js (UNYC.accordion), exécuté avant (ordre des fichiers).
 * Remplace le composant Vue Faq.
 */
UNYC.register('faq', () => {
    UNYC.init('[data-faq]', 'faq', (root) => {
        const params = new URLSearchParams(window.location.search);
        const param = (key) => (params.has(key) ? params.get(key) : null);
        const categories = UNYC.qsa('.categories a', root);
        const select = root.querySelector('.select select');
        const cat = param('cat');
        const term = param('term');
        const question = param('question');
        let active = -1;

        const setActive = (index) => {
            if (index === active) return;

            const previous = categories[active];
            const next = categories[index];

            if (previous) previous.classList.remove('active');
            if (next) next.classList.add('active');

            active = index;
        };

        if (cat && select) {
            Array.from(select.options).forEach((option) => {
                if (option.value === cat) option.selected = true;
            });
        }

        if (select) {
            select.addEventListener('change', () => {
                window.location.href = `?cat=${select.value}`;
            });
        }

        categories.forEach((link, index) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                UNYC.scrollTo(link.hash);
                setActive(index);
            });
        });

        /* Liens profonds */
        if (term) {
            UNYC.scrollTo(`#${term}`);
        }

        if (question) {
            UNYC.accordion.toggleItem(`#faq-${question}`, term);
        }

        /* Scroll-spy */
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const id = entry.target.id;

                categories.forEach((link, index) => {
                    if (link.hash.slice(1) !== id) return;

                    if (entry.isIntersecting) {
                        setActive(index);
                    } else if (active === index) {
                        setActive(-1);
                    }
                });
            });
        }, { threshold: 1, rootMargin: '0px 0px -50% 0px' });

        UNYC.qsa('.questions .question--wrapper', root).forEach((wrapper) => observer.observe(wrapper));
    });
});
